import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { CardWrapper, WelcomeCard } from 'src/pages/Welcome/style';
import ButtonComponent from 'src/components/ButtonComponent';
import { useNavigate } from 'react-router-dom';

export interface Props {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isUserAdmin: boolean;
}

const LastThreeCards: React.FC<Props> = ({ setModalIsOpen, isUserAdmin }) => {
  const navigate = useNavigate();

  const goToManualLookup = () => {
    navigate('/lookup');
  };

  const goToUsers = () => {
    navigate('/admin/users');
  };
  return (
    <CardWrapper container>
      <Grid item xs={12} md={isUserAdmin ? 4 : 6}>
        <WelcomeCard>
          <Box>
            <Typography variant="h5">Try our products</Typography>
            <Typography variant="body2">Look up an Email, Phone, IP address, Device or Browser to find out if it&apos;s suspicious.</Typography>
          </Box>
          <Box>
            <ButtonComponent data-testid="manual-lookup-button" text="Manual Lookup" buttontype="cancel" onClick={goToManualLookup} />
          </Box>
        </WelcomeCard>
      </Grid>
      {isUserAdmin && (
        <Grid item xs={12} md={4}>
          <WelcomeCard>
            <Box>
              <Typography variant="h5">Add team members</Typography>
              <Typography variant="body2">Our permission system makes collaboration easy.</Typography>
            </Box>
            <Box>
              <ButtonComponent data-testid="team-management-button" text="Add team members" buttontype="cancel" onClick={goToUsers} />
            </Box>
          </WelcomeCard>
        </Grid>
      )}
      <Grid item xs={12} md={isUserAdmin ? 4 : 6}>
        <WelcomeCard>
          <Box>
            <Typography variant="h5">Talk to an expert</Typography>
            <Typography variant="body2">Schedule a quick introductory call to know more about how to use Trustfull</Typography>
          </Box>
          <Box>
            <ButtonComponent data-testid="request-demo-button" text="Request a demo" buttontype="cancel" onClick={() => setModalIsOpen(true)} />
          </Box>
        </WelcomeCard>
      </Grid>
    </CardWrapper>
  );
};

export default LastThreeCards;
